import { createContext, useContext, useMemo } from 'react'
import { createLocalStorageSync } from './hooks/use-local-storage-sync'
import type { ExpenseTypeFilter } from './utils'

type ExpenseTypeContextValue = {
  expenseType: ExpenseTypeFilter
  setExpenseType: (s: ExpenseTypeFilter) => void
}

export const ExpenseTypeContext = createContext<ExpenseTypeContextValue | null>(null)

const useExpenseTypeStorage = createLocalStorageSync<ExpenseTypeFilter>(
  'expense-type-preference',
  'all',
  (raw) => (raw === 'all' || raw === 'fixed' || raw === 'variable' ? raw : null),
)

export function ExpenseTypeProvider({ children }: { children: React.ReactNode }) {
  const [expenseType, setExpenseType] = useExpenseTypeStorage()

  const value = useMemo<ExpenseTypeContextValue>(
    () => ({ expenseType, setExpenseType }),
    [expenseType, setExpenseType],
  )

  return (
    <ExpenseTypeContext.Provider value={value}>
      {children}
    </ExpenseTypeContext.Provider>
  )
}

export function useExpenseType(): ExpenseTypeContextValue {
  const ctx = useContext(ExpenseTypeContext)
  if (!ctx) throw new Error('useExpenseType must be used within ExpenseTypeProvider')
  return ctx
}
